// extracted by mini-css-extract-plugin
export default {"wrapper":"AnalyticsHeader_wrapper__r2Stw","title":"AnalyticsHeader_title__8sOr9"};